var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-filters',
                        view: publicPath + 'sprite.svg#view-icon-filters',
                        viewBox: '0 0 15 15',
                        title: 'Icon / Settings',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };